import { CircleIcon, InfoIcon } from 'app/agriculture/icons';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import './StatHealth.scss';
import { useCallback, useContext } from 'react';
import { DeviceStatusContext } from 'app/agriculture/routes/Devices/utils/status/DeviceStatusContext';
import { statusToColour } from 'app/agriculture/routes/Devices/utils/status/statusToColour';
import { statusToString } from 'app/agriculture/routes/Devices/utils/status/statusToString';
import { IconButton } from 'app/agriculture/components/Button/Button';
import { Popover } from 'app/agriculture/components/Popover/Popover';
import { IconType } from 'react-icons';

interface StatHealthProps {
    hideLabel?: boolean;
}

export function StatHealth({ hideLabel = false }: StatHealthProps) {
    const { status, messages } = useContext(DeviceStatusContext);

    const Icon = useCallback<IconType>(
        (props) => <CircleIcon {...props} size={10} color={statusToColour[status]} />,
        [status],
    );

    return (
        <StatDisplay
            name={hideLabel ? null : 'Status'}
            value={
                <div className="StatHealth__value">
                    <h5>{statusToString[status]}</h5>
                    {messages.length === 0 ? null : (
                        <Popover>
                            <Popover.Trigger>
                                <IconButton
                                    className="StatHealth__icon-button"
                                    variant="textonly"
                                    icon={<InfoIcon color={statusToColour[status]} />}
                                    tooltip="See status messages"
                                />
                            </Popover.Trigger>
                            <Popover.Content>
                                {messages.map((message) => (
                                    <p key={message}>{message}</p>
                                ))}
                            </Popover.Content>
                        </Popover>
                    )}
                </div>
            }
            className="StatHealth"
            Icon={Icon}
        />
    );
}
